<script context="module">
  const productTileDefaultOptions = {
    showFavIcon: true,
    mobileTileWidth: 150,
    desktopTileWidth: 255,
    favIconMobileWidth: 0,
    favIconDesktopWidth: 25,
    mobileImageWidth: 90,
    desktopImageWidth: 150,
    mobileImageHeight: 90,
    desktopImageHeight: 150,
  };
</script>

<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';

  import { productTileStore } from '../store/product-tile_store';

  import { onMount } from 'svelte';
  import { isMobileWidth } from '../../../common/util';
  import { getCartLoginDetails } from '../../header/services/header-service';
  import { cartLoginDetails } from '../../header/store/header_store';
  import { addToWishlist } from '../../home/services/home-data-services';
  import { getAddToWishlistDataPlp } from '../../product-listing-search/services/plp-data-services';
  import { mapToTileData, setRMNContext } from '../services/banner-utils';
  import ProductCardNewPrice from './ProductCardNewPrice.svelte';
  import ProductTileHeader from './productTile/components/ProductTileHeader.svelte';
  import ProductTileName from './productTile/components/ProductTileName.svelte';

  const { pageId } = getAppConfig();

  export let data: any = {};
  export let index = 0;
  const tileData = mapToTileData(data);
  const isResponsive = isMobileWidth();

  let wishlistedProductCodes = [];
  export let options = {};

  $: productCode = data?.code || data?.productCode;

  $: wishlisted = wishlistedProductCodes && wishlistedProductCodes.indexOf(productCode) > -1;

  $: opt = { ...productTileDefaultOptions, ...options };
  const setMixpanelData_AddToWishlist = res => {
    setTimeout(() => {
      var data = getAddToWishlistDataPlp(res);
      window['ACC'].mixpanel.track('Product Added to Wishlist', {
        ...data,
      });
    }, 2000);
  };

  cartLoginDetails.subscribe(cld => {
    wishlistedProductCodes =
      cld?.customer?.wishlist?.entries?.filter(x => x.product !== null).map(x => x.product?.code) || [];
  });

  let productStore = null;

  function toggleWishlist(data) {
    console.log('toggleWishlist', data);
    // addToWishlist
    data.detail.event.stopPropagation();
    data.detail.event.preventDefault();
    const productCode = data?.detail?.productCode || tileData?.product?.productCode;

    if (productCode) {
      addToWishlist(productCode)
        .then(res => {
          if (res.success === false) {
            window.location.assign(res.redirectUrl);
          } else {
            // add to wishlist success, get new cartDetails
            window['ACC'].extragtm.click.addToWishlistV2(tileData?.product);
            getCartLoginDetails();
            setMixpanelData_AddToWishlist(res?.product);
            document.querySelector('.js-wishlist-count').innerHTML = res.wishlistSize;
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => window['ACC'].loader.hideLoader());
    }
  }
  const onRMNProductTileClick = product => {
    if (product.miraklad) {
      window.ACC.miraklads.registerClickAsync(product.miraklad.adId);
    }
    setRMNContext({
      banner_type: 'Shoppable Ad',
      source_name: window['ACC']?.utils?.getSourceNameForCurrentPage(),
    });
  };

  onMount(() => {
    productStore = productTileStore(data);
    if (!wishlistedProductCodes.length && getAppConfig()?.wishlistProducts?.length && !$cartLoginDetails) {
      wishlistedProductCodes = [...getAppConfig().wishlistProducts];
    }
  });
</script>

{#if productStore}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <section
    class="rmn-product-card"
    style:--mobile-tile-width="{opt?.mobileTileWidth}px"
    style:--desktop-tile-width="{opt?.desktopTileWidth}px"
    on:click={() => onRMNProductTileClick(data)}
  >
    <div class="image-box {pageId === 'productDetails' ? 'pdp' : ''}">
      <section class="heder-conatiner tags-wishlist" style="position: relative; z-index: 1">
        <ProductTileHeader
          data={tileData}
          options={{
            showFavIcon: opt?.showFavIcon,
            favIconMobileWidth: opt?.favIconMobileWidth,
            favIconDesktopWidth: opt?.favIconDesktopWidth,
            isWishlisted: wishlisted,
          }}
          on:changeWishList={data => {
            toggleWishlist(data);
          }}
        />
      </section>

      <div class="image {pageId !== 'productDetails' ? 'plp' : ''}">
        <!-- svelte-ignore a11y-img-redundant-alt -->
        <img
          src={isResponsive
            ? `${tileData?.amplienceProductBaseUrl}?fmt=auto&h=60`
            : `${tileData?.amplienceProductBaseUrl}?fmt=auto&h=${
                pageId === 'productList' || pageId === 'search' ? 121 : 170
              }`}
          alt="Product image"
        />
      </div>
    </div>
    <div
      class="title {pageId !== 'productDetails' ? 'plp-title' : ''} {tileData?.miraklSponsored
        ? 'mirakl-sponsored'
        : ''}"
    >
      <ProductTileName data={tileData} showSponsoredTag={pageId === 'productDetails' ? false : true} />
    </div>

    <ProductCardNewPrice {data} variant="compact" />
  </section>
{/if}

<style lang="scss">
  @import '../styles/colors.new.scss';

  .rmn-product-card {
    width: var(--desktop-tile-width);
    border-radius: 16px;
    background: $primary-white;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;

    @include desktop-max-width {
      max-width: var(--mobile-tile-width);
      padding: 8px;
    }
    .plp-title {
      :global {
        .tile-name-container {
          font-size: 10px !important;
          line-height: 14px !important;
          @include desktop-max-width {
            font-size: 8px !important;
            line-height: 10px !important;
          }
        }
      }
    }
    :global {
      .product-name-data {
        display: block;
        line-height: 20px;
        @include desktop-max-width {
          line-height: 12px;
        }
      }
      .dot {
        display: none !important;
      }
      .product-name {
        -webkit-line-clamp: 2 !important;
        line-clamp: 2;
        @include desktop-max-width {
          -webkit-line-clamp: 3 !important;
          line-clamp: 3;
        }
      }
      .mirakl-sponsored-tag {
        margin-bottom: 0 !important;
      }
      .tile-head-container {
        position: absolute !important;
        top: 6px !important;
        left: auto !important;
        gap: 2px !important;
        .primary-icon {
          @include desktop-max-width {
            height: 18px !important;
            width: 18px !important;
            box-shadow: 0px 0.86px 3.44px 0px #0000001a;
            padding: 2px;
          }
          height: 25px !important;
          width: 25px !important;
        }
        .tag-container {
          display: none !important;
        }
      }
    }
  }

  .image-box {
    position: relative;
    background: $primary-white;
    border-radius: 12px;
    padding: 4px;
    border: 1px solid $color-gray-border;
    &.pdp {
      min-height: 232px;
      @include desktop-max-width {
        min-height: 122px;
      }
    }
    .image {
      display: flex;
      justify-content: center;
      padding: 24px 0;
      &.plp {
        padding: 24px 0 0;
        @include desktop-max-width {
          padding: 0;
        }
      }
    }
    @include desktop-max-width {
      border: 0;
      padding: 2px;
    }
    :global {
      .tile-head-container {
        top: 0 !important;
        right: 4px !important;
        gap: 2px;
        .primary-icon {
          height: 25px !important;
          width: 25px !important;
          @include desktop-max-width {
            height: 18px !important;
            width: 18px !important;
            box-shadow: 0px 0.86px 3.44px 0px #0000001a;
            padding: 2px;
          }
        }
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 4px 2px;
  }

  .mirakl-sponsored {
    :global {
      .product-name {
        -webkit-line-clamp: 3 !important;
        line-clamp: 3;
      }
    }
  }
</style>
